import React from 'react';
import { CircularProgress } from '@mui/material';
import { TP_COLORS } from '../../constants';

interface FullScreenLoaderProps {
  matchHeightWithHeader?: boolean;
}

const FullScreenLoader: React.FC<FullScreenLoaderProps> = ({
  matchHeightWithHeader,
}) => {
  const containerStyles: React.CSSProperties = {
    width: '100%',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  };

  if (matchHeightWithHeader) {
    containerStyles.height = 'calc(100vh - 64px)';
  }

  return (
    <div style={containerStyles}>
      <CircularProgress
        color="primary"
        sx={{ color: TP_COLORS.tutopiyaGreenMain.light }}
      />
    </div>
  );
};

export default FullScreenLoader;
